import { createStore, stateSetterHandler } from '@alpha.apps/react-common';
import { UnipalInitOrderModel } from '@/services';

export interface VerifiedOfferModel {
  id: string;
  isBankOfferApplied?: boolean;
  isUnipalOfferApplied?: boolean;
  isCardOfferApplied?: boolean;
}

export type VerifiedOfferState = {
  verifiedOffer: VerifiedOfferModel | null;
};

const verifiedOfferInitState: VerifiedOfferState = {
  verifiedOffer: null,
};

export const useVerifiedOffer = createStore({
  name: 'verifiedOffer',
  devtools: true,
  persist: true,
  getStorage: () => sessionStorage,
})(verifiedOfferInitState, set => {
  const handler = stateSetterHandler(set);
  return {
    setVerifiedOffer: handler('verifiedOffer'),
  };
});

export type VerifiedOfferBinState = {
  verifiedOfferBin: string | null;
  verifiedOfferLast4Bin: string | null;
  verifiedExpiryMonth: string | null;
  verifiedExpiryYear: string | null;
};

const verifiedOfferBinInitState: VerifiedOfferBinState = {
  verifiedOfferBin: null,
  verifiedOfferLast4Bin: null,
  verifiedExpiryMonth: null,
  verifiedExpiryYear: null,
};

export type VerifiedUnipalOfferState = {
  verifiedUnipalOffer: UnipalInitOrderModel | null;
};

const verifiedUnipalOfferInitState: VerifiedUnipalOfferState = {
  verifiedUnipalOffer: null,
};

export const useVerifiedOfferBin = createStore({
  name: 'verifiedOfferBin',
  devtools: true,
  persist: true,
})(verifiedOfferBinInitState, set => {
  const handler = stateSetterHandler(set);
  return {
    setVerifiedOfferBin: handler('verifiedOfferBin'),
    setVerifiedOfferLast4Bin: handler('verifiedOfferLast4Bin'),
    setVerifiedOfferExpiryMonth: handler('verifiedExpiryMonth'),
    setVerifiedOfferExpiryYear: handler('verifiedExpiryYear'),
  };
});

export const useVerifiedUnipalOffer = createStore({
  name: 'verifiedUnipalOffer',
  devtools: true,
  persist: true,
})(verifiedUnipalOfferInitState, set => {
  const handler = stateSetterHandler(set);
  return {
    setVerifiedUnipalOffer: handler('verifiedUnipalOffer'),
  };
});
